import { get, post } from '../../utils/axios'

export const listIncomeShiftAPI = async (body) => {
  return await get('income/shift', body)
}
export const detailIncomeShiftAPI = async (body) => {
  return await get('income/shift/detail', body)
}
export const importIncomeShiftAPI = async (body) => {
  return await post('income/shift/import', body)
}
export const deleteIncomeShiftAPI = async (body) => {
  return await post('income/shift/delete', body)
}
